export default "<div id=\"{{elementId}}\" style=\"width: 97%; height: 400px;\"></div>";